/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/continue-education': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z" _fill="#000" fill-rule="evenodd"/>'
  }
})
